//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FeaturedCheckbox from '@/components/search/FeaturedCheckbox'
import { mapState } from 'vuex'
import CountriesDropdown from '@/components/search/CountriesDropdown'
import CategoriesDropdown from '../search/CategoriesDropdown.vue'
import QuickSearch from '../ui/QuickSearch.vue'
import SkillsDropdown from '../search/SkillsDropdown.vue'
import LanguagesDropdown from '~/components/search/LanguagesDropdown'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'FreelancersSearchHeading',
  components: {
    CountriesDropdown,
    FeaturedCheckbox,
    SkillsDropdown,
    QuickSearch,
    CategoriesDropdown,
    LanguagesDropdown
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('freelancers', {
      term: 'term',
      category: 'category',
      languages: 'languages',
      skill: 'skill',
      featured: 'featured',
      country: 'country'
    })
  },
  methods: {
    async selectCategory (category) {
      // save old selection for comparison later on
      const oldCategory = this.category
      await this.$store.dispatch('freelancers/setCategory', category)

      // if category changed then reset selected skill
      if (category !== oldCategory) {
        await this.$store.dispatch('freelancers/setSkill', null)
      }

      this.$emit('search')
    },
    async selectSkill (s) {
      await this.$store.dispatch('freelancers/setSkill', s)
      this.$emit('search')
    },
    async selectLanguages (languages) {
      await this.$store.dispatch('freelancers/setLanguages', languages)
      this.$emit('search')
    },
    async handleFeaturedToggle (value) {
      await this.$store.dispatch('freelancers/setFeatured', value)
      this.$emit('search')
    },
    async search (e) {
      await this.$store.dispatch('freelancers/setSearchTerm', e)
      this.$emit('search')
    },
    async selectCountry (country) {
      await this.$store.dispatch('freelancers/setCountry', country)
      this.$emit('search')
    }
  }
}
